// extracted by mini-css-extract-plugin
export default {"root":"UserCard_root__26E2Z","avatar":"UserCard_avatar__tdAHG","title":"UserCard_title__FB9s7"};